import React from 'react';
import { Award, Shield, Clock, Users } from 'lucide-react';
import { aboutData, contadoraData } from '../../data/mock';
import elianaPhoto from '../../assets/eliana.jpeg';
import '../../styles/landing.css';

const features = [
  { icon: Shield, text: 'Confidencialidad' },
  { icon: Clock, text: 'Puntualidad' },
  { icon: Users, text: 'Trato Personal' },
  { icon: Award, text: 'Experiencia' }
];

const AboutSection = () => {
  return (
    <section className="section section-light">
      <div className="container">
        <div className="about-content">
          <div className="about-image-container">
            <div className="about-image-box">
              <img 
                src={elianaPhoto} 
                alt={contadoraData.nombre}
                className="about-portrait"
                data-testid="about-eliana-photo"
              />
            </div>
          </div>
          
          <div className="about-text">
            <div className="section-label">Sobre Mí</div>
            <h2 className="heading-1">{aboutData.title}</h2>
            <p className="lead">{contadoraData.nombre}</p>
            <p className="body-large">{aboutData.description}</p>
            
            <div className="about-features">
              {features.map((feature, index) => (
                <div key={index} className="about-feature">
                  <div className="about-feature-icon">
                    <feature.icon size={20} />
                  </div>
                  <span className="body-medium font-semibold">{feature.text}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
